export const WaveDivider = ({ color = "#4A90E2", flip = false, className = "" }) => (
  <div className={`relative w-full overflow-hidden leading-[0] ${flip ? "rotate-180" : ""} ${className}`} aria-hidden="true">
    <svg
      className="relative block h-[60px] w-[calc(200%+1.3px)] animate-[wave-slide_12s_linear_infinite]"
      viewBox="0 0 1200 120"
      preserveAspectRatio="none"
    >
      <path
        d="M0,60 C150,120 350,0 600,60 C850,120 1050,0 1200,60 L1200,120 L0,120 Z"
        fill={color}
      />
    </svg>
  </div>
);
